import { ComponentFactoryResolver, Injectable, Injector } from '@angular/core';
import { AlertOptions } from '../interfaces/options.interface';
import { AlertData } from '../interfaces/data.interface';
import { AlertComponent } from '../components/alert/alert.component';
import { ModalStackService } from '../../modals/services/modal-stack.service';
import { ModalRef } from '../../modals/classes/modal-ref';

@Injectable()
export class AlertService {

    constructor(private componentFactoryResolver: ComponentFactoryResolver, private injector: Injector, private stack: ModalStackService) {
    }

    /**
     * Open a new modal with the given component or template ref.
     *
     * @param {AlertData} data
     * @param {AlertOptions} options
     * @return {ModalRef}
     */
    public open(data: AlertData, options: AlertOptions = {}): ModalRef {
        return this.stack.open(this.componentFactoryResolver, this.injector, AlertComponent, data, options);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/alerts/services/alert.service.ts